import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Product from '../Product/Product';

const Products = () => {
    const aam = [
        {
            id: 1,
            name: 'হিমসাগর/খিরসাপাত',
            location: 'চাঁপাইনবাবগঞ্জ',
            price: "১০০",
            img:"https://rajajinationalpark.org/wp-content/uploads/jangli-aam-1.jpg"
        },
        {
            id: 2,
            name: 'গোপালভোগ',
            location: 'চাঁপাইনবাবগঞ্জ',
            price: "১০০",
            img:"https://i.ibb.co/317dzM4/gopalvog.jpg"
        },
        {
            id: 3,
            name: 'আমরুপালি',
            location: 'চাঁপাইনবাবগঞ্জ',
            price: "১০০",
            img:"https://i.ibb.co/ZTg02VP/amrupali.jpg"
        },
        {
            id: 4,
            name: 'হাড়িভাঙ্গা',
            location: 'চাঁপাইনবাবগঞ্জ',
            price: "১০০",
            img:"https://i.ibb.co/3cGPSp3/harivanga.jpg"
        },
        {
            id: 5,
            name: 'ল্যাংরা',
            location: 'চাঁপাইনবাবগঞ্জ',
            price: "১০০",
            img:"https://i.ibb.co/g3CbFBm/langra.jpg"
        },
        {
            id: 6,
            name: 'মল্লিকা',
            location: 'চাঁপাইনবাবগঞ্জ',
            price: "১০০",
            img:"https://i.ibb.co/cXxtYwZ/mollika.jpg"
        }
    ]
    return (
        <div className='py-5'>
            <Container>

                <h2 className='text-center mb-5'>আমাদের আম সমূহ </h2>

                <div>
                    <Row xs={1} md={2} lg={3} className="g-4">
                        {
                            aam.map(am => <Product key={am.id} am={am} />)
                        }

                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default Products;